import ButtonCloseMenu from 'components/button-close'
import { useHistory } from 'react-router-dom'
import textServices from 'services/text-services'


export default function Levels() {
  const history = useHistory()

  return (
    <>
      <ButtonCloseMenu paramFn={() => history.push('/home')} />
      <div className="w-full flex flex-col items-center my-8 space-y-4">
        <img src={`${AZURE_BASE_URL}/levels-page.webp`} alt='page levels' />
        <button type="button" className="cursor-pointer button-back" onClick={() => history.push('/home')}>
          {textServices.findByText('backButton', { es: 'VOLVER', en: 'BACK TO' })}
        </button>
      </div>
    </>
  )
}